/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Closed
 *
 * 1 = Active
 */
export enum RecallStatus {
  Closed = 0,
  Active = 1,
}
